/* Drømmemøbler – Gruppebyggeren, del 1: katalog. Bygger produktlistene fra dataene i sections/dm-gruppebygger.liquid. */
window.DMGB = window.DMGB || {};
DMGB.bygg = function (RAW) {
  'use strict';
  var MIN_CHAIRS = +RAW.min_chairs || 6;
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var kr = function (ore) { return Math.round(ore / 100).toLocaleString('nb-NO') + ' kr'; };

  /* ---------- bygg katalogen ---------- */
  var ALL = {};
  function item(kind, src, extra) {
    var o = { kind: kind, id: kind + ':' + src.h, name: src.t, url: src.u, img: src.i, parts: [{ v: src.v, p: src.p, s: src.s }] };
    for (var k in extra || {}) o[k] = extra[k];
    return finish(o);
  }
  function finish(o) {
    o.price = o.parts.reduce(function (s, p) { return s + p.p; }, 0);
    o.stock = Math.min.apply(null, o.parts.map(function (p) { return p.s; }));
    ALL[o.id] = o; return o;
  }
  function lines(txt) {
    return String(txt || '').split(/\r?\n/).map(function (l) { return l.trim(); })
      .filter(function (l) { return l && l.charAt(0) !== '#'; })
      .map(function (l) { return l.split('|').map(function (x) { return x.trim(); }); });
  }
  function byHandle(list) { var m = {}; (list || []).forEach(function (p) { m[p.h] = p; }); return m; }
  function lc(s) { return String(s || '').toLowerCase(); }

  function tableShape(name) {
    var n = lc(name);
    if (/\bsett\b|set of|2 bord/.test(n)) return 'pair';
    if (/(^|\D)(120|150)(\D|$)|oval|ellips/.test(n)) return 'oval';
    return 'round';
  }
  function diningShape(name) {
    var n = lc(name);
    if (/ø\s?\d|rund/.test(n)) return 'round';
    if (/uttrekk|optimum|saba|donato|noah/.test(n)) return 'rect';
    return 'oval';
  }
  function inferSeats(name, shape) {
    var nums = (String(name).match(/\d{2,3}/g) || []).map(Number).filter(function (x) { return x >= 60 && x <= 400; });
    var len = nums.length ? Math.max.apply(null, nums) : 200;
    if (len <= 100) return 4;
    if (len <= 140) return 6;
    if (len <= 170) return shape === 'round' ? 8 : 6;
    if (len <= 250) return 8;
    if (len <= 300) return 10;
    return 12;
  }
  function shapeWord(w) { w = lc(w); if (w.indexOf('rund') === 0) return 'round'; if (w.indexOf('rekt') === 0 || w.indexOf('firk') === 0) return 'rect'; if (w.indexOf('oval') === 0) return 'oval'; return ''; }

  var LOUNGE = {
    sofa3: (RAW.sofa3 || []).map(function (p) { return item('sofa3', p); }),
    sofa2: (RAW.sofa2 || []).map(function (p) { return item('sofa2', p); }),
    corner: (RAW.corner || []).map(function (p) { return item('corner', p); }),
    chair: (RAW.chair || []).map(function (p) { return item('chair', p); }),
    table: (RAW.ltable || []).map(function (p) { return item('ltable', p, { shape: tableShape(p.t) }); }),
    extra: (RAW.extra || []).map(function (p) { return item(/puff|krakk|fotskammel/.test(lc(p.t)) ? 'puff' : 'side', p); })
  };
  var lparts = byHandle(RAW.lparts);
  lines(RAW.corner_sets).forEach(function (l, i) {
    var hs = (l[1] || '').split('+').map(function (h) { return h.trim(); }).filter(Boolean);
    var ps = hs.map(function (h) { return lparts[h]; });
    if (!hs.length || ps.some(function (p) { return !p; })) { if (window.console) console.warn('Gruppebygger: mangler modul i', l.join(' | ')); return; }
    LOUNGE.corner.push(finish({ kind: 'corner', id: 'corner:set' + i, name: l[0], url: ps[0].u, img: ps[0].i,
      note: ps.length + ' moduler', parts: ps.map(function (p) { return { v: p.v, p: p.p, s: p.s }; }) }));
  });

  var seatMap = {};
  lines(RAW.seats).forEach(function (l) { seatMap[l[0]] = { seats: +l[1] || 0, shape: shapeWord(l[2]) }; });
  function dTable(p, h) {
    var o = seatMap[p.h] || {}, shape = o.shape || diningShape(p.t);
    return item('dtable', p, { h: h, shape: shape, seats: o.seats || inferSeats(p.t, shape) });
  }
  var DINING = {
    table: [].concat(
      (RAW.dtable_std || []).map(function (p) { return dTable(p, 'std'); }),
      (RAW.dtable_low || []).map(function (p) { return dTable(p, 'low'); })),
    chair: [].concat(
      (RAW.dchair_std || []).map(function (p) { return item('dchair', p, { h: 'std' }); }),
      (RAW.dchair_low || []).map(function (p) { return item('dchair', p, { h: 'low' }); }))
  };
  var dparts = byHandle([].concat(RAW.dparts || [], RAW.dparts2 || []));
  lines(RAW.dining_sets).forEach(function (l, i) {
    var hs = (l[1] || '').split('+').map(function (h) { return h.trim(); }).filter(Boolean);
    var ps = hs.map(function (h) { return dparts[h]; });
    if (!hs.length || ps.some(function (p) { return !p; })) { if (window.console) console.warn('Gruppebygger: mangler borddel i', l.join(' | ')); return; }
    var shape = shapeWord(l[4]) || diningShape(l[0]);
    DINING.table.push(finish({ kind: 'dtable', id: 'dtable:set' + i, name: l[0], url: ps[0].u, img: ps[0].i,
      h: lc(l[2]).indexOf('lav') === 0 ? 'low' : 'std', shape: shape, seats: +l[3] || inferSeats(l[0], shape),
      note: 'Bordplate og understell', parts: ps.map(function (p) { return { v: p.v, p: p.p, s: p.s }; }) }));
  });

  return { ALL: ALL, LOUNGE: LOUNGE, DINING: DINING, MIN_CHAIRS: MIN_CHAIRS, esc: esc, kr: kr, lc: lc };
};